import {CouponHistoryStatus} from '@/enums';
import {palette} from '@/styles';

/** 쿠폰 코드 원문 길이 */
export const COUPON_CODE_LENGTH = 10;

/** 화면 표기 시 하이픈을 삽입하는 위치 (XXXXX-XXXXX) */
export const COUPON_CODE_GROUP_SIZE = 5;

/** 등록 만료 D-7 이내는 강조 표기 */
export const COUPON_DEADLINE_IMMINENT_DAYS = 7;

/** 로그인 알림 세션당 1회 노출 판단 키 */
export const COUPON_LOGIN_ALERT_SESSION_KEY = 'coupon-login-alert-shown';

/** 진입 카드 조회 이벤트 세션당 1회 전송 판단 키 */
export const COUPON_ENTRY_CARD_VIEW_SESSION_KEY = 'coupon-entry-card-viewed';

/** /plans 진입 시 보유 쿠폰 모달을 바로 열기 위한 쿼리 파라미터 */
export const COUPON_MODAL_OPEN_PARAM = 'coupon';

/** GA4 이벤트명 (PRD US-05 표기 그대로 사용) */
export const COUPON_EVENTS = {
  entryCardView: '보유쿠폰_진입카드_조회',
  modalOpen: '보유쿠폰_모달_열기',
  itemSelect: '보유쿠폰_항목선택',
  codeSubmit: '보유쿠폰_코드등록_제출',
  codeSuccess: '보유쿠폰_코드등록_성공',
  codeFail: '보유쿠폰_코드등록_실패',
  startComplete: '보유쿠폰_시작완료',
  loginAlertView: '보유쿠폰_로그인알림_노출',
  loginAlertClick: '보유쿠폰_로그인알림_이동클릭',
  loginAlertClose: '보유쿠폰_로그인알림_닫기',
};

/**
 * 이용 이력의 고객 노출 상태.
 * 관리자 회수(Released)도 사유·회수 시점을 숨기고 만료로 안내한다.
 */
export const COUPON_HISTORY_STATUS = {
  [CouponHistoryStatus.Active]: {label: '이용중', color: palette.green500},
  [CouponHistoryStatus.Completed]: {label: '이용 완료', color: palette.gray600},
  [CouponHistoryStatus.Expired]: {label: '만료', color: palette.gray400},
  [CouponHistoryStatus.Released]: {label: '만료', color: palette.gray400},
  [CouponHistoryStatus.Suspended]: {label: '이용 중지', color: palette.gray600},
};

/** 고객 노출 문구 */
export const COUPON_MESSAGES = {
  formatError: '영문과 숫자 10자리를 확인해 주세요',
  registerSuccess: '쿠폰을 등록했어요. 아래에서 선택해 주세요.',
  registerSuccessWhileActive:
    '등록했어요. 현재 이용권이 끝난 뒤 사용할 수 있어요.',
  registerServerError:
    '일시적인 오류가 발생했어요. 잠시 후 다시 시도해 주세요.',
  listError: '쿠폰 목록을 불러오지 못했어요. 다시 시도해 주세요.',
  empty: '보유한 쿠폰이 없어요. 쿠폰 코드를 등록해 보세요.',
  activePassNotice:
    '현재 이용 중인 이용권이 있어 쿠폰을 시작할 수 없어요. 이용이 끝난 뒤 사용해 주세요.',
  deadlineBeforePassEnd: '현재 이용권 종료 전에 만료될 예정이에요',
  disappearAfterDeadline: '등록 만료일 이후에는 목록에서 사라져요.',
  confirmTitle: '이 쿠폰을 사용할까요?',
  confirmWarning: '시작하면 오늘부터 이용 기간이 차감되며 직접 취소할 수 없습니다.',
  useStarted: '쿠폰 사용을 시작했어요!\n1초 후 지도 페이지로 이동합니다.',
  useFailed: '쿠폰 사용에 실패했어요. 잠시 후 다시 시도해 주세요.',
  historyEmpty: '이용 이력이 없습니다.',
  historyLoading: '이용 이력을 불러오는 중입니다.',
};
